var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18.5,
    viewBox: "0.75 0.7 18.5 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.906a5.25 5.25 0 1 1 0 .088z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.3125,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Ellipse 204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 9.904a9.25 9.25 0 1 1 0 .092z",
    strokeDasharray: 2.7750000000000004,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.3875000000000002,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Ellipse 206"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.39d6653cabe0f28a219f5d5a741f377c.svg";
export { ForwardRef as ReactComponent };